export enum DisplayTypes {
	FullScreen = 'full-screen',
	ActionPanel = 'action-panel'
}
